import PropTypes from 'prop-types'
import { Box, Center, Heading, HStack, Text, VStack } from '@chakra-ui/react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React from 'react'
import UnderlineHeading from '../../../components/UnderlineText/UnderlineHeading'
import { ToastComponent } from '../../../utils/theme/additions/toast/Toast'
import { colors } from '../../../utils/theme/styles'
import useButtonSelector from '../../../utils/hooks/useButtonSelector/useButtonSelector'
import Factory from './components/Factory'
import Selector from '../../../components/Selector/Selector'
import localCompany from '../../../api/repository/localStorage/localCompany'

function Report({ title, icon, onClick }) {
  return (
    <Center
      onClick={onClick}
      cursor="pointer"
      {...ToastComponent.variants.report}
    >
      <HStack>
        <FontAwesomeIcon icon={icon} />
        <Text
          variant="semibold"
          fontSize="16px"
          fontWeight="semibold"
          textTransform="uppercase"
          color={colors.gray[800]}
        >
          {title}
        </Text>
      </HStack>
    </Center>
  )
}

Report.propTypes = {
  icon: PropTypes.any,
  onClick: PropTypes.func,
  title: PropTypes.string,
}

const reportsOptions = [
  { id: 0, label: 'Cuenta NN empresa', value: 'nnreport' },
  { id: 1, label: 'Consumo empresa', value: 'companyConsumption' },
  { id: 2, label: 'Resumen de ordenes de compra', value: 'purchaseOrders' },
  {
    id: 3,
    label: 'Informe de recargas diarias por colaborador',
    value: 'dailyRefills',
  },
  {
    id: 4,
    label: 'Detalle recargas empresa',
    value: 'refillReport',
  },
  {
    id: 5,
    label: 'Detalle Saldo de Colaboradores',
    value: 'partnersList',
  },
  {
    id: 6,
    label: 'Detalle de Recargas de Colaboradores',
    value: 'PartnersBalance',
  },
]

const reportsWithCasino = [
  ...reportsOptions,
  {
    id: 5,
    label: 'Informe de consumo casino',
    value: 'casinoReport',
  },
]

export default function ManagementReports() {
  const user = localCompany.getUserData()
  const options = user.oEmpresa[0]?.bCasino ? reportsWithCasino : reportsOptions

  const { selected, onSelectedChange } = useButtonSelector(options)
  return (
    <VStack w="100%" px="2%" spacing="32px" h="75vh" alignItems="flex-start">
      <UnderlineHeading
        color="#676767"
        text="Informes de gestión"
        variant="h5"
        subtext="Genera diferentes reportes desde una fecha determinada y exportalos en formato excel. "
        subVariant="body1"
      />
      <VStack
        spacing="20px"
        alignItems="flex-start"
        justifyContent="flex-start"
        w="100%"
      >
        <Heading variant="h5">Acciones</Heading>
        <Text variant="subtitle2">
          Elige el tipo de reporte que deseas exportar
        </Text>
        <HStack
          justifyContent="flex-start"
          alignItems="flex-start"
          width="100%"
          wrap="wrap"
          gap="40px"
        >
          <Box
            minW="max-content"
            w={['100%', '70%', '50%', '20%', '30%', '25%']}
          >
            <Selector
              isClearable
              placeholder="Seleccione un tipo de reporte"
              options={options}
              onChange={onSelectedChange}
            />
          </Box>
        </HStack>
        <HStack>
          <Box>
            <Factory selected={selected} />
          </Box>
        </HStack>
      </VStack>
    </VStack>
  )
}
